module.exports = __webpack_public_path__ + "img/HumaneWorld-V-RGB-White.883c3c16.png";